<template>
  <div v-loading="loading">
    <el-row class="margin-v3">
      <el-col :span="8">
        姓名：{{reportDetail.patientName}}
      </el-col>
      <el-col :span="8">
        性别：{{reportDetail.gender}}
      </el-col>
      <el-col :span="8">
        年龄：{{reportDetail.age}}岁
      </el-col>
    </el-row>
    <div class="dashed-line">
    </div>
    <el-row class="margin-v3">
      <el-col :span="12">
        开单科室：{{reportDetail.billDeptName}}
      </el-col>
      <el-col :span="12">
        开单医生：{{reportDetail.billDoctorName}}
      </el-col>
    </el-row>
    <el-row class="margin-v3">
      <el-col :span="12">
        报告单号：{{reportDetail.reportId}}
      </el-col>
      <el-col :span="12">
        执行科室：{{reportDetail.exeDeptName}}
      </el-col>
    </el-row>
    <div style="height: 5px;background-color: #f5f7f9"></div>
    <el-row style="padding-left: 5px;">
      <el-col :span="24" class="margin-v3">
        检验项目：{{reportDetail.projectName}}
      </el-col>
      <el-col :span="24" class="margin-v3">
        标本类别：{{reportDetail.specimenType}}
      </el-col>
      <el-col :span="24" class="margin-v3">
        开单时间：{{reportDetail.billTime}}
      </el-col>
      <el-col :span="24" class="margin-v3">
        检验时间：{{reportDetail.execTime}}
      </el-col>
      <el-col :span="24" class="margin-v3">
        报告时间：{{reportDetail.reportTime}}
      </el-col>
    </el-row>
    <div style="background-color: #f7f8fc; color: #909399">
      <div>
        <span class="margin-h7">注：</span>
        <i class="el-icon-top" style="color: #e99441"></i>
        <span>偏高</span>
        <i class="el-icon-bottom" style="color: #e99441;margin-left: 10px;"></i>
        <span>偏低</span>
      </div>
      <div style="display: flex;background-color: #5190f9; align-items: center; padding: 8px 12px; color: white; ">
        <div style="width: 40%">
          检查项目
        </div>
        <div style="width: 20%">
          结果
        </div>
        <div style="width: 20%">
          单位
        </div>
        <div style="width: 20%">
          参考值
        </div>
      </div>
      <div style="display: flex; align-items: center; padding: 8px 12px; color: #909399; " v-for="(item, index) in reportDetail.details" :key="index">
        <div style="width: 40%">
          {{item.itemName}}
        </div>
        <div style="width: 20%">
          {{item.result}}
        </div>
        <div style="width: 20%">
          {{item.unit}}
        </div>
        <div style="width: 20%">
          {{item.refValue}}
        </div>
      </div>

    </div>
  </div>
</template>

<script>
  import {getReportDetail} from "@/api/op/record";

  export default {
    props: {
      reportId: {
        type: String,
        default: "",
      },
      reportType: {
        type: String,
        default: "",
      },
    },
    data() {
      return {
        loading: false,
        reportDetail: {}
      }
    },
    watch: {
      reportId() {
        this.queryReportDetail();
      }
    },
    mounted() {
      this.queryReportDetail();
    },
    methods: {
      queryReportDetail() {
        this.loading = true;
        getReportDetail(this.reportId, this.reportType)
          .then((res) => {
            this.reportDetail = res.data.data;
            this.loading = false;
          }).finally(() => {
          this.loading = false;
        });
      }
    }
  }
</script>
<style lang="scss" scoped>
</style>
